module.exports = __webpack_public_path__ + "img/religion.7b0ad4ac.svg";